// Vendors
import gsap from "gsap";
// Storages
import { GridStorage } from "shared/storages";
// Game instance
import { Game } from "screens/game/game";
// Models
import { Block } from "shared/model";
// Event Emmiten
import { EventBus } from "shared/emmiter";
import { DefaultConfig } from "shared/config";
import { Main } from "screens/main";
import { LevelObject } from "shared/levels";

export class CoincidencesService {
    public static getAllChains(grid: Block[][]) {
        let result: [][] = new Array<[]>();
        let row: number;
        let col: number;
        for (row = 0; row < grid.length; row++) {
            result = result.concat(CoincidencesService.getHorizontalChains(grid, row));
        }

        for (col = 0; col < grid.length; col++) {
            result = result.concat(CoincidencesService.getVerticalChains(grid, col));
        }

        if (result.length > 0) {
            this.deleteChains(result);
        }
    }

    private static deleteChains(chains): void {
        for (let i = 0; i < LevelObject.columns; i++) {
            let shift = 0;
            for (let j = LevelObject.rows - 1; j >= 0; j--) {
                const tile = LevelObject.tiles[i][j];

                if (tile.type === -1) {
                    shift += 1;
                    gsap.to(tile, {
                        alpha: 0, duration: 0.3, ease: 'none', onComplete: () => {
                            LevelObject.tiles[i].splice(j, 1);
                        }
                    })
                } else {
                    LevelObject.tiles[i][j].shift = shift;
                }
            }
        }

        this.moveBlocks();
    }

    private static moveBlocks(): void {
        for (let i = 0; i < LevelObject.columns; i++) {
            for (let j = LevelObject.rows - 1; j >= 0; j--) {
                const tile = LevelObject.tiles[i][j];
                if (tile && tile.shift > 0) {
                    gsap.to(tile, {y: `+=${tile.height * tile.shift}`, duration: 1.5, ease: 'none'})
                }
            }
        }
    }

    private static showNewBlocks(block): void {
        const newSprite = this.getRandomChain();
        block.texture = newSprite.texture;
        block.color = newSprite.color;
        block.type = newSprite.type;
        gsap.to(block, {alpha: 1, duration: 0.3})
    }

    private static getRandomChain() {
        const colors = DefaultConfig.colors;

        const color = colors[Math.floor(Math.random() * colors.length)]
        let sprite;
        switch (color) {
            case 'red': {
                sprite.texture = Main.instance.app.loader.resources.red.texture;
                sprite.color = 'red';
                sprite.type = 1;
                break;
            }
            case 'green': {
                sprite.texture = Main.instance.app.loader.resources.pink.texture;
                sprite.color = 'green';
                sprite.type = 2;
                break;
            }
            case 'pink': {
                sprite.texture = Main.instance.app.loader.resources.dark_purp.texture;
                sprite.color = 'pink';
                sprite.type = 3;
                break;
            }
            case 'white': {
                sprite.texture = Main.instance.app.loader.resources.purp.texture;
                sprite.color = 'white';
                sprite.type = 4;
                break;
            }
            case 'yellow': {
                sprite.texture = Main.instance.app.loader.resources.tile_5.texture;
                sprite.color = 'yellow';
                sprite.type = 5;
                break;
            }
        }

        return sprite;
    }

    public static getHorizontalChains(grid, row: number): any[] {
        const result: any[][] = new Array<[]>();
        let horizontal: any[];
        let piece;
        let pieceBefore;
        let col: number;
        pieceBefore = grid[0][row];
        horizontal = new Array();
        horizontal.push(pieceBefore);
        for (col = 1; col < grid.length; col++) {
            piece = grid[col][row];

            if (piece.type === pieceBefore.type) {
                horizontal.push(piece);
            } else {
                if (horizontal.length >= 3) {
                    result.push(horizontal);
                }
                horizontal = new Array();
                horizontal.push(piece);
            }

            pieceBefore = piece;
        }
        if (horizontal.length >= 3) {
            result.push(horizontal);
        }

        if (result.length && result[0].length >= 3) {
            for (let i = 0; i < result[0].length; i++) {
                LevelObject.tiles[result[0][i].col][result[0][i].row].type = -1;
            }
        }

        return result;
    }
    public static getVerticalChains(grid, col: number): any[] {
        const result: any[][] = new Array();
        let vertical: any[];
        let piece;
        let pieceBefore;
        let row: number;

        pieceBefore = grid[col][0];

        vertical = new Array();
        vertical.push(pieceBefore);

        for (row = 1; row < grid.length; row++) {
            piece = grid[col][row];

            if (piece.type === pieceBefore.type) {
                vertical.push(piece);
            } else {
                if (vertical.length >= 3) {
                    result.push(vertical);
                }
                vertical = new Array();
                vertical.push(piece);
            }

            pieceBefore = piece;
        }
        if (vertical.length >= 3) {
            result.push(vertical);
        }
        if (result.length && result[0].length >= 3) {
            for (let i = 0; i < result[0].length; i++) {
                LevelObject.tiles[result[0][i].col][result[0][i].row].type = -1;
            }
        } 

        return result;
    }
}